import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { Button } from "./ui/button";

type InsertEInvoiceReferenceProps = {
  isOpen: boolean;
  onClose: () => void;
  onFilled: (uuid: string) => void;
};

const InsertEInvoiceReference = ({
  isOpen,
  onClose,
  onFilled,
}: InsertEInvoiceReferenceProps) => {
  const [referenceNumber, setReferenceNumber] = useState<string>("");

  const handleOnClick = () => {
    onFilled(referenceNumber);
    setReferenceNumber("");
    onClose();
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Original e-Invoice Reference Number</DialogTitle>
          <DialogDescription>
            Manually insert reference number
          </DialogDescription>
        </DialogHeader>
        <Label htmlFor="originalUUID" required>
          UUID
        </Label>
        <Input id="originalUUID" 
            value={referenceNumber}
            onChange={(e) => setReferenceNumber(e.target.value)}
        />
        <div className="flex justify-end gap-4">
          <Button size="sm" variant="outline" type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button size="sm" type="button" onClick={handleOnClick}>
            Done
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InsertEInvoiceReference;
